class TemplateAndQuestions {
  suggestedQuestions: PreBuiltQuestionsType[];

  constructor(params?: DefaultQuestionsType | null) {
    this.suggestedQuestions = params?.suggestedQuestions || [];
  }
}

export { TemplateAndQuestions };
